<template>
  <div
    class="indiamart-webhook-box"
    :class="{ 'indiamart-webhook-box--wide': wide }"
  >
    <p
      v-if="showHeading"
      class="text-slate-700 dark:text-slate-200 font-medium mt-4 mb-2"
    >
      {{ $t('INBOX_MGMT.ADD.INDIAMART_CHANNEL.API_CALLBACK.TITLE') }}
    </p>
    <woot-code lang="html" :script="webhookUrl" />
  </div>
</template>

<script>
export default {
  props: {
    webhookUrl: {
      type: String,
      required: true,
    },
    showHeading: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.indiamart-webhook-box {
  width: 100%;

  &--wide {
    width: 90%;
    max-width: 90%;
    margin-left: 5%;
  }

  ::v-deep .code--container {
    position: relative;
    width: 100%;
    min-height: 6.5rem;
    border-radius: var(--border-radius-large);
    padding: 2.75rem 1.25rem 1.25rem;
    @apply bg-slate-50 dark:bg-slate-700;
  }

  ::v-deep .code--container pre,
  ::v-deep .code--container .hljs {
    background: transparent !important;
    margin: 0 !important;
    padding: 0 !important;
    white-space: pre-wrap !important;
    word-break: break-all;
    overflow: hidden !important;
    max-height: none !important;
    text-align: center;
    line-height: 1.5;
  }

  ::v-deep .code--action-area {
    position: absolute;
    top: 0.75rem;
    right: 0.75rem;
    z-index: 1;
  }
}
</style>
